import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-primary-900 text-background-100">
    <div className="layout-shell grid grid-cols-1 gap-8 py-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10 lg:py-14">
      <div className="sm:col-span-2 lg:col-span-1">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 font-heading text-lg font-bold text-primary-900">
            瓜
          </span>
          <span className="font-heading text-lg font-bold">瓜田追踪</span>
        </div>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
          一个专注“爆料后续”的追踪站。我们把零散的爆料整理成可追溯的事件档案，用时间线呈现反转、辟谣与当事人回应。
        </p>
      </div>

      <div>
        <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">浏览栏目</h4>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><a href="/#hot" className="text-background-200 transition-colors hover:text-background-50">今日引爆</a></li>
          <li><a href="/#rank" className="text-background-200 transition-colors hover:text-background-50">热搜追踪榜</a></li>
          <li><a href="/#archive" className="text-background-200 transition-colors hover:text-background-50">反转档案</a></li>
          <li><a href="/#timeline" className="text-background-200 transition-colors hover:text-background-50">最新时间线</a></li>
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">核实与声明</h4>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><a href="/#rumor" className="text-background-200 transition-colors hover:text-background-50">辟谣专区</a></li>
          <li><a href="/#faq" className="text-background-200 transition-colors hover:text-background-50">常见问题</a></li>
          <li><a href="/#about" className="text-background-200 transition-colors hover:text-background-50">关于我们</a></li>
          <li><Link to="/case/mcn-contract-split" className="text-background-200 transition-colors hover:text-background-50">事件示例档案</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">联系与纠错</h4>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li className="flex items-center gap-2 text-background-200">
            <i className="ri-mail-line" aria-hidden="true" />
            <a href="mailto:hello@guatian-zhui.example" className="transition-colors hover:text-background-50">hello@guatian-zhui.example</a>
          </li>
          <li className="flex items-center gap-2 text-background-200">
            <i className="ri-edit-2-line" aria-hidden="true" />
            <a href="/#about" className="transition-colors hover:text-background-50">提交线索与更正</a>
          </li>
          <li className="flex items-center gap-2 text-background-200">
            <i className="ri-information-line" aria-hidden="true" />
            <span>内容会随进展持续更新</span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-background-50/15">
      <div className="layout-shell flex flex-col items-center justify-between gap-3 py-5 text-xs text-background-200 sm:flex-row">
        <p>© 2026 瓜田追踪 · 理性看待爆料，以官方与当事人公开信息为准</p>
        <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          <span>内容仅供参考与讨论</span>
          <span aria-hidden="true" className="hidden sm:inline">·</span>
          <span>涉及争议请以官方通报为准</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;